import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.scss";

const TestimonialText = ({ text, maxChars = 180 }) => {
    const [expanded, setExpanded] = useState(false);
    const isLong = text.length > maxChars;
    const displayText = expanded ? text : text.slice(0, maxChars) + (isLong ? "..." : "");

    return (
        <div className="text-wrapper">
            <div className={`text ${expanded ? "expanded" : ""}`}>{displayText}</div>
            {isLong && (
                <span
                    className="read-more"
                    onClick={(e) => {
                        e.stopPropagation();
                        setExpanded(!expanded);
                    }}
                >
          {expanded ? "Show less" : "Read more"}
        </span>
            )}
        </div>
    );
};

// Helper to build avatar URLs
const generateAvatarUrl = (firstName, lastName) => {
    const fullName = `${firstName} ${lastName}`;
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(
        fullName
    )}&background=24243b&color=fff`;
};

const Testimonials = () => {
    const rawFeedback = [
        {
            date: "Apr 12, 2023",
            text: "Working with Roy on the Migrart website development has been an amazing experience. His dedication and commitment throughout the project were incredible. We’re proud of him for understanding our vision and transforming it into a dynamic and user-friendly platform.\n\nWe also appreciated his quick communication and timely delivery. MigrArt is an online database platform for migrant artists based in Poland, fully financed by the city of Warsaw through STREFA WOLNOSŁOWA.\nThank you for your service.",
            firstName: "Stanley",
            lastName: "Ndua",
            title: "Coordinator, Migrart",
        },
        {
            date: "Jan 10, 2022",
            text: "Working with Roy to design my language school’s website was a fantastic experience. From the start, Roy understood my needs and created a modern, intuitive, and user-friendly site.",
            firstName: "Karina",
            lastName: "Radczuk",
            title: "Founder, Made In English",
        },
        {
            date: "Nov 1, 2025",
            text: "Working with Techadive on the Slyzed mobile app was an outstanding experience. The team took the time to deeply understand our goals and delivered a sleek, user-friendly product that perfectly matched our vision.\n" +
                "\n" +
                "The process was smooth from start to finish — clear communication, thoughtful design decisions, and quick turnaround times.\n" +
                "\n" +
                "The final app not only looks fantastic but also provides our clients with a seamless, customizable e-commerce solution. We couldn’t be happier with the result!",
            firstName: "Julius",
            lastName: "Angwenyi",
            title: "Project Manager, Slyzed",
        },
    ];

    // Automatically enrich feedback with full name + avatar
    const feedback = rawFeedback.map((f) => ({
        ...f,
        name: `${f.firstName} ${f.lastName}`,
        avatar: generateAvatarUrl(f.firstName, f.lastName),
    }));

    const sliderRef = useRef(null);
    const [visibleCards, setVisibleCards] = useState({});
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;
        const cards = slider.querySelectorAll(".testimonial-card");

        const observer = new IntersectionObserver(
            (entries) => {
                const newVisible = {};
                entries.forEach((entry) => {
                    const index = parseInt(entry.target.dataset.index, 10);
                    newVisible[index] = entry.intersectionRatio >= 0.8;
                });
                setVisibleCards((prev) => ({ ...prev, ...newVisible }));
            },
            { root: slider, threshold: [0, 0.5, 0.8, 1] }
        );

        cards.forEach((card) => observer.observe(card));
        return () => observer.disconnect();
    }, []);

    return (
        <section className="testimonials">
            <h2>What Our Clients Say</h2>
            <div className="testimonials__wrapper" ref={sliderRef}>
                {feedback.map((f, i) => {
                    const isVisible = visibleCards[i];
                    const isActive = i === activeIndex;

                    return (
                        <div
                            key={i}
                            data-index={i}
                            className={`testimonial-card ${isVisible ? "visible" : "blurred"} ${
                                isActive ? "active" : ""
                            }`}
                            onClick={() => setActiveIndex(i)}
                        >
                            <div className="date">{f.date}</div>
                            <TestimonialText text={f.text} />
                            <div className="divider"></div>
                            <div className="author">
                                <img src={f.avatar} alt={f.name} />
                                <div>
                                    <h4>{f.name}</h4>
                                    <span>{f.title}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default Testimonials;
